module.exports = __webpack_public_path__ + "static/img/pagination-next-icon.b41d4ea0.svg";